import React, { Fragment } from "react";
import { Redirect } from "react-router-dom";

export const ProtectedRoute = ({ authData, children }) => {
  console.log("AuthData", authData);
  return (
    <div>
      {authData.isLogin ? (
        <Fragment>{children}</Fragment>
      ) : window.location.pathname.includes("/admin") ? (
        <Redirect to={"/admin/login"} />
      ) : (
        <Redirect to={"/login"} />
      )}
    </div>
  );
};
